import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AccountInvoiceSearchModel} from "../account-invoice-search.model";
import {AccountInvoiceEntityModel} from "../account-invoice-entity.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";

@Component({
    selector: "wbo-account-invoice-search-page",
    templateUrl: "./account-invoice-search-page.component.html",
    providers: [provideSearchModel(AccountInvoiceSearchModel), provideEntityModel(AccountInvoiceEntityModel)]
})
export class AccountInvoiceSearchPageComponent extends AbstractSearchPage {

}
